(() => {
  function init(root) {
    if (root.dataset.ofkTitleReady) return;
    const island = root.querySelector('[data-ofk-title-data]');
    if (!island) return;
    let data;
    try { data = JSON.parse(island.textContent); } catch { return; }
    root.dataset.ofkTitleReady = 'true';
    function update(id) {
      const title = data.variants[String(id)];
      if (!title) return;
      root.querySelectorAll('[data-ofk-display-title]').forEach(el => { el.textContent = title; });
      root.dataset.productTitle = title;
    }
    root.addEventListener('variant:change', event => update(event.detail?.variant?.id));
    document.addEventListener('variant:change', event => {
      const id = event.detail?.variant?.id;
      if (id && Object.hasOwn(data.variants, String(id))) update(id);
    });
    root.addEventListener('change', () => requestAnimationFrame(() => {
      const selected = root.querySelector('form[action*="/cart/add"] [name="id"]');
      if (selected) update(selected.value);
    }));
    update(data.initial);
  }
  function scan() { document.querySelectorAll('.product-section').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('quickview:loaded', scan);
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();